import { render } from "./Generalinfos.vue?vue&type=template&id=800a98a8"
import script from "./Generalinfos.vue?vue&type=script&lang=ts"
export * from "./Generalinfos.vue?vue&type=script&lang=ts"
script.render = render

export default script